// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4808":"acd7f867","6477":"b1b68b0a"}[chunkId] + ".chunk.css";
};